const translations = {
    title: 'Strona główna',
    description: '',
    canonical: 'string',
    image: '',
    robots: '',
};

export default translations;